import { render, staticRenderFns } from "./LffAboutMe.vue?vue&type=template&id=b4b4e42e&scoped=true&"
import script from "./LffAboutMe.vue?vue&type=script&lang=js&"
export * from "./LffAboutMe.vue?vue&type=script&lang=js&"
import style0 from "./LffAboutMe.vue?vue&type=style&index=0&id=b4b4e42e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b4e42e",
  null
  
)

export default component.exports